import { AnnouncementPoller } from '../../announcements/AnnouncementPoller'

// Session start is what opens the popup, and a refresh is not one — the platform
// decides which this is, so nothing above it has to know how the two differ.
export class AnnouncementSessionStartTask {
    constructor(onAnnouncements) {
        this.name = 'AnnouncementSessionStartTask'
        this.poller = new AnnouncementPoller({ announcements: onAnnouncements })
    }

    async run({ platform, fetcher }) {
        if (!platform?.isSessionStart?.()) {
            return
        }

        try {
            const response = await fetcher.fetchAnnouncementsForCurrentUser()
            this.poller.receive(response)
        }
        catch (error) {
            console.error('AnnouncementSessionStartTask: could not fetch announcements:', error)
        }
    }
}
